import {Command} from "./Command";
import {LooseGamePlay} from "../model/game-play";
import {ODK} from "../model/odk";

export class SetOdkCommand implements Command {
  constructor(
    private gamePlay: LooseGamePlay,
    private odk: ODK
  ) { }

  execute() {
    console.log('COMMAND SetOdkCommand', this.odk)
    this.gamePlay.odk = this.odk
  }
}
